import { type MessageInstance } from "antd/es/message/interface";

import { privateAPI } from "../../../_config/constants";
import { errorHandler } from "../../_utils";
import { type PolicyFormType, store } from "..";
import { setPolicies, setPolicyLoading } from "../slices/policySlice";

export const getPolicies = async (notify: MessageInstance) => {
  try {
    store.dispatch(setPolicyLoading(true));
    const response = await privateAPI.get("/policies/admin");
    if (response) {
      store.dispatch(setPolicyLoading(false));
      store.dispatch(setPolicies(response.data));
    }
    return response;
  } catch (error) {
    store.dispatch(setPolicyLoading(false));
    console.error("Get Policy Error:", error);
    errorHandler(error, notify);
  }
};

export const createPolicy = async (
  notify: MessageInstance,
  payload: PolicyFormType,
) => {
  try {
    store.dispatch(setPolicyLoading(true));
    const { data } = await privateAPI.post("/policies", payload);
    notify.success("Policy created successfully!");
    return data;
  } catch (error) {
    console.error("Create Policy Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setPolicyLoading(false));
  }
};

export const updatePolicy = async (
  notify: MessageInstance,
  payload: PolicyFormType,
) => {
  try {
    if (!payload.id) return;
    store.dispatch(setPolicyLoading(true));
    const { data } = await privateAPI.patch(`/policies/${payload.id}`, payload);
    notify.success("Policy updated successfully!");
    return data;
  } catch (error) {
    console.error("Update policy Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setPolicyLoading(false));
  }
};

export const deletePolicy = async (
  notify: MessageInstance,
  id: string,
  getData = false,
) => {
  try {
    store.dispatch(setPolicyLoading(true));
    const response = await privateAPI.delete(`/policies/${id}`);
    if (response) {
      getData && (await getPolicies(notify));
    }
    notify.success("Policy deleted successfully!");
    return response;
  } catch (error) {
    console.error("Delete Policy Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setPolicyLoading(false));
  }
};

export const uploadPolicyCsv = async (
  notify: MessageInstance,
  payload: FormData,
) => {
  try {
    store.dispatch(setPolicyLoading(true));
    const response = await privateAPI.post(`/policies/bulk-upload`, payload);
    if (response) {
      await getPolicies(notify);
    }
    notify.success("Policies uploaded successfully!");
    return response;
  } catch (error) {
    console.error("Policies upload Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setPolicyLoading(false));
  }
};
